import * as React from 'react';
import { buildClassName } from 'utils/build-class-name';
import styles from './progress.module.scss';

interface ProgressProps extends React.HTMLAttributes<HTMLDivElement> {
  value?: number;
}

const Progress = React.forwardRef<HTMLDivElement, ProgressProps>(
  ({ className, value = 0, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={buildClassName(styles.progress, className)}
        {...props}
      >
        <div
          className={styles.indicator}
          style={{ transform: `translateX(-${100 - value}%)` }}
        />
      </div>
    );
  }
);
Progress.displayName = 'Progress';

export { Progress };
